/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../../helper/URLHelper';

import AssistantWizard from './wizard/components/AssistantWizard.vue';
import SettingWrapper from '../SettingsWrapper.vue';
import SettingsContent from '../Wrapper.vue';

import InboxHome from './Index.vue';
import Settings from './Settings.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/assistants'),
      component: SettingWrapper,
      props: params => {
        return {
          headerTitle: 'ASSISTANT_MGMT.HEADER',
          headerButtonText: 'SETTINGS.ASSISTANTS.NEW_ASSISTANT',
          icon: 'bot',
          newButtonRoutes: ['settings_assistant_new'],
        };
      },
      children: [
        {
          path: 'new',
          name: 'settings_assistant_new',
          component: AssistantWizard,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: '',
          name: 'settings_assistant',
          redirect: 'list',
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'list',
          name: 'settings_assistant_list',
          component: InboxHome,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/assistants/:assistantId'),
      component: SettingsContent,
      props: route => {
        return {
          headerTitle: 'ASSISTANT_MGMT.HEADER',
          headerButtonText: 'SETTINGS.INBOXES.NEW_INBOX',
          icon: 'bot',
          newButtonRoutes: ['settings_assistant_list'],
          showBackButton: true,
          largeWidth: true,
        };
      },
      children: [
        {
          path: '',
          name: 'settings_assistant_show',
          component: Settings,
          meta: {
            permissions: ['administrator'],
          },
          props: route => {
            return {
              assistantId: route.params.assistantId,
            };
          },
        },
      ],
    },
  ],
};
